import { Component, Input, OnInit } from '@angular/core';
declare var $: any;
import * as _ from 'lodash';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NcdclientService } from 'src/app/services/NCD/ncdclient.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AlloteesNewComponent } from '../allotees-new/allotees-new.component';
import { AlertComponent } from '../../alert/alert.component';
@Component({
  selector: 'app-allotees',
  templateUrl: './allotees.component.html',
  styleUrls: ['./allotees.component.css']
})
export class AlloteesComponent implements OnInit {
  isSearchDivVisible = false;
  dtElement: DataTableDirective;
  dtAllotteesList: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  @Input('issueId') issueId: any;

  ncdAllotteesList: any;
  allotteeId: any;
  deleteAllotteeId: any;

  // Search variables
  investorCodeModel: any = '';
  nameModel: any = '';
  investorCategoryModel: any = '';
  investorSubcategoryModel: any = '';
  dpTypeModel: any = '';
  dpIdModel: any = '';
  existingAllotteesInvestorCodeList: any = [];
  issueDetails: any;

  dpTypeList = ["NSDL", "CDSL"];

  constructor(private ncdClientService: NcdclientService,
    private modalService: NgbModal, private alert: AlertComponent) { }

  ngOnInit() {
    this.dtAllotteesList = {
      processing: true,
      serverSide: false,
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateDuration: -1,
      scrollY: "420px",
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      autoWidth: false,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [23] }, { className: "hide_col", targets: [0, 3, 4, 5, 6, 7, 8, 9, 11, 12, 15, 16, 17] }],
      // columnDefs: [{ orderable: false, targets: [4] }, { className: "hide_col", targets: [5,6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'NCD-Allottees List',
          title: 'NCD-Allottees List',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
            format: {
              body: function (data, row, column, node) {
                if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                } else { return data }
              }
            }
            // columns: [0, 1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92]
          }
        }
      ]
    };

    // console.log("issueDetails",this.issueDetails);
    this.getExistingAllotteesInvestorCodeList();
    this.getAllotteesList({ isSearch: false });
  }

  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  getExistingAllotteesInvestorCodeList() {
    this.ncdClientService.getExistingAllotteesList()
      .subscribe(response => {
        if (response.status == 0) {
          this.existingAllotteesInvestorCodeList = response.data;
        } else {
          // this.alert.error(response.message);
        }
      });
  }

  getAllotteesList(searchObj) {
    this.ncdAllotteesList = [];
    $("#allotteesListTable").DataTable().destroy();
    this.ncdClientService.getAllAllotteeListByIssueId(this.issueId, searchObj).subscribe((issueDetailsById: any) => {
      this.issueDetails = issueDetailsById.issueDetails[0];
      this.ncdAllotteesList = issueDetailsById.data;
      this.dtTrigger.next();
    })

  }

  loadncdAllotteesByID(id, status) {
    const modalRef = this.modalService.open(AlloteesNewComponent, {
      backdrop: 'static',
      size: "lg"
    })

    modalRef.componentInstance.allotteeId = id;
    modalRef.componentInstance.allotteeStatus = status;
    modalRef.componentInstance.issueDetails = this.issueDetails;

    modalRef.result.then(resp => {
      this.getAllotteesList({ isSearch: false });
    }, (error) => {
    })

  }

  confirmDelete(id) {
    this.deleteAllotteeId = id;
    $("#confirmDeleteAllottee").modal('toggle');
  }

  deleteNcdIssueSpecificAllottees() {

    this.ncdClientService.deleteIsssueSpecificAllottees(this.issueDetails._id, this.deleteAllotteeId)
      .subscribe((response: any) => {
        if (response.status == 0) {
          this.alert.success(response.message);
        } else {
          this.alert.error(response.message);
        }
        this.getAllotteesList({ isSearch: false });

      });
  }

  doAdvSearch() {

    if (this.investorCodeModel == '' && this.nameModel == '' && this.investorCategoryModel == '' && this.investorSubcategoryModel == '' && this.dpTypeModel == '' && this.dpIdModel == '') {
      this.alert.success("Fill atleast one search field");
    } else {

      var searchnewFieldObject = {};
      if (this.investorCodeModel != '') {
        searchnewFieldObject['investorCode'] = this.investorCodeModel;
      }
      if (this.nameModel != '') {
        searchnewFieldObject['name'] = this.nameModel;
      }
      if (this.investorCategoryModel != '') {
        searchnewFieldObject['investorCategory'] = this.investorCategoryModel;
      }
      if (this.investorSubcategoryModel != '') {
        searchnewFieldObject['investorSubCategory'] = this.investorSubcategoryModel;
      }
      if (this.dpTypeModel != '') {
        searchnewFieldObject['dpType'] = this.dpTypeModel;
      }
      if (this.dpIdModel != '') {
        searchnewFieldObject['dpID'] = this.dpIdModel;
      }

      searchnewFieldObject['isSearch'] = true;
      // console.log("this.investorCodeModel",searchnewFieldObject);
      // searchnewFieldObject = {
      //   'investorCode': this.investorCodeModel,
      //   'name': this.nameModel,
      //   'investorCategory': this.investorCategoryModel,
      //   'investorSubcategory': this.investorSubcategoryModel,
      //   'dpType': this.dpTypeModel,
      //   'dpId': this.dpIdModel,
      //   'isSearch': true
      // }

      this.getAllotteesList(searchnewFieldObject);
    }
  }

  clearAdvSearch() {
    this.investorCodeModel = '';
    this.nameModel = '';
    this.investorCategoryModel = '';
    this.investorSubcategoryModel = '';
    this.dpTypeModel = '';
    this.dpIdModel = '';
    this.getAllotteesList({ isSearch: false });
  }

}
